import React from 'react';

/** 將文字中的 URL 轉成可點擊連結 */
export default function LinkifyText({ text, style, linkColor = '#2563eb' }) {
  if (!text) return null;
  const urlRegex = /(https?:\/\/[^\s<]+)/g;
  const parts = String(text).split(urlRegex);
  return (
    <span style={style}>
      {parts.map((part, i) => (
        urlRegex.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: linkColor, textDecoration: 'underline', wordBreak: 'break-all' }}
          >
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      ))}
    </span>
  );
}
